import {
  CountRange,
  GroupAnalyticsFilters,
} from '@/components/filter/FilterItems';
import { UnitAnalyticsSummary } from '@/types/unit-analytics-summary';

export function unitPassesFilters(
  summary: UnitAnalyticsSummary,
  filters: GroupAnalyticsFilters,
): boolean {
  if (filters.missedCalls === 'missed' && summary.missedCalls === 0) {
    return false;
  }
  if (filters.missedCalls === 'answered' && summary.answeredCalls === 0) {
    return false;
  }

  if (filters.callEndedBy === 'staff' && summary.callsEndedByStaff === 0) {
    return false;
  }
  if (
    filters.callEndedBy === 'service-user' &&
    summary.callsEndedByUser === 0
  ) {
    return false;
  }

  if (filters.callDuration !== 'all') {
    const maxMinutes = parseInt(filters.callDuration, 10);
    if (
      summary.totalCalls === 0 ||
      summary.maxCallDurationMinutes > maxMinutes
    ) {
      return false;
    }
  }

  if (!passesCountFilter(summary.totalCalls, filters.callsMade)) return false;
  if (!passesCountFilter(summary.notificationsSent, filters.notificationsSent))
    return false;
  if (!passesCountFilter(summary.announcementsSent, filters.announcementsSent))
    return false;
  if (
    !passesCountFilter(
      summary.notificationResponses,
      filters.notificationResponses,
    )
  )
    return false;

  return true;
}

function passesCountFilter(count: number, filter: CountRange): boolean {
  if (filter === 'all') return true;
  const threshold = parseInt(filter, 10);
  return count >= threshold;
}
